__webpack_require__.p = "//cdn0.canvaspeople.com/static/redesign/";